import FieldList from '@/components/DynamicForm/config/FieldList';
import DisplayForm from '@/components/DynamicForm/config/DisplayForm';
import FieldConfigForm from '@/components/DynamicForm/config/FieldConfigForm';
import React, { useEffect, useState } from 'react';
import {
  TCustomField,
  TDynamicFormConfig,
  TRequirementFieldConfig,
} from '@/components/DynamicForm/model';
import { parseDefaultValue } from '@/components/DynamicForm/utils';
import arrayMove from 'array-move';
import './index.less';
import { Button, message, Modal } from 'antd';
import { useRequest } from '@@/plugin-request/request';
import { getDynamicForm, listCustomField, upsertDynamicForm } from '@/services/DynamicFormRequest';
import { useParams } from 'umi';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { UncommittedProps } from '@/pages/backend/cardCampSettings';
import { DragEndEvent } from '@dnd-kit/core/dist/types';

export default function EntryFormConfig({ setHasUncommitted }: UncommittedProps) {
  const { id: campId } = useParams<{ id: string }>();
  const [selectedFieldId, setSelectedFieldId] = useState<string>();
  const [requirementType, setRequirementType] = useState<TDynamicFormConfig>();
  const [customFieldList, setCustomFieldList] = useState<TCustomField[]>([]);
  const [defaultRequirement, setDefaultRequirement] = useState({});
  const [fields, setFields] = useState<TRequirementFieldConfig[]>([]);

  useEffect(() => {
    getDynamicFormRun();
    listCustomFieldRun();
  }, [campId]);

  useEffect(() => {
    if (requirementType) {
      const requirement = parseDefaultValue(requirementType.fields || []);
      setDefaultRequirement({ ...requirement, requirementType });
      setFields(requirementType.fields || []);
    }
  }, [requirementType]);

  const setRequirementTypeState = (type: TDynamicFormConfig) => {
    setRequirementType(type);
    setHasUncommitted(true);
  };

  const { run: getDynamicFormRun } = useRequest(
    () => {
      return getDynamicForm(campId);
    },
    {
      manual: true,
      onSuccess: (data) => {
        setRequirementType(data || { campId: campId });
        setHasUncommitted(false);
      },
      onError: (e) => {
        message.error(e.message);
      },
    },
  );

  const { run: listCustomFieldRun } = useRequest(
    () => {
      return listCustomField(campId);
    },
    {
      manual: true,
      onSuccess: (data) => {
        setCustomFieldList(data);
      },
      onError: (e) => {
        message.error(e.message);
      },
    },
  );

  const onSortEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      // @ts-ignore
      setFields((prev) => {
        const oldIndex = prev.findIndex((item) => item.id === active.id);
        const newIndex = prev.findIndex((item) => item.id === over?.id);
        return arrayMove(fields, oldIndex, newIndex);
      });
    }
  };

  const { run: upsertDynamicFormRun } = useRequest(
    () => {
      if (requirementType) {
        return upsertDynamicForm({ ...requirementType, fields: fields });
      } else {
        return Promise.resolve();
      }
    },
    {
      manual: true,
      onSuccess: () => {
        setHasUncommitted(false);
        message.success('保存成功');
      },
      onError: (e) => {
        message.error(e.message);
      },
    },
  );
  return (
    <div className={'type-config-modal'}>
      <div className={'ant-modal-body'}>
        <FieldList
          campId={campId}
          customFieldList={customFieldList || []}
          listCustomField={listCustomFieldRun}
          fields={fields}
          setFields={setFields}
        />
        <DisplayForm
          campId={campId}
          onFieldSelect={setSelectedFieldId}
          selectedFieldId={selectedFieldId || ''}
          customFieldList={customFieldList}
          onSortEnd={onSortEnd}
          requirement={defaultRequirement}
          fields={fields}
        />
        <FieldConfigForm
          requirement={defaultRequirement}
          selectedFieldId={selectedFieldId}
          fields={fields}
          setFields={setFields}
        />
      </div>
      <div className="config-footer">
        <Button
          type={'primary'}
          onClick={() => {
            Modal.confirm({
              title: '确认保存吗？',
              icon: <QuestionCircleOutlined />,
              onOk: () => {
                if (requirementType) {
                  requirementType.fields = Array.isArray(requirementType?.fields)
                    ? requirementType?.fields.filter((field) => {
                        if (field.fieldType == 'custom') {
                          return (
                            customFieldList.findIndex(
                              (customField) => customField.id === field.customFieldEntityId,
                            ) > -1
                          );
                        } else {
                          return true;
                        }
                      })
                    : [];
                  upsertDynamicFormRun();
                }
              },
            });
          }}
        >
          保存更改
        </Button>
      </div>
    </div>
  );
}
